export const CATEGORY = 'State';

export const CATEGORIES = {
  INVESTMENT: 'Trade and Investment',
  JOBS: 'Jobs',
  EDUCATIONAL_EXCHANGE: 'Educational Exchange',
  PEOPLE: 'People-to-People Connections',
};

export const ITEMS = {
  GOOD_EXPORTS: 'Goods Exports (US$)',
  SERVICE_EXPORTS: 'Services Exports (US$)',
  TOTAL_EXPORTS: 'Total Exports (US$)',
  GREENFIELD: 'Greenfield Investment since 2003 (US$)',
  JOBS_DIRECTLY: 'Jobs Directly Supported by Exports',
  JOBS_INIDRECTLY: 'Jobs Indirectly Supported by Exports',
  JOBS_CREATED: 'Jobs Created by Investment',
  NUMBER_OF_STUDENTS: 'Number of Students',
  ECONOMIC_IMPACT: 'Economic Impact of Students (US$)',
  VISITOR_SPENDING: 'Visitor Spending (US$)',
  POPULATION: 'Population',
  NUMBER_OF_SISTER_CITIES: 'Number of Sister Cities',
};

export const CATEGORIES_LIST = [
  CATEGORIES.INVESTMENT,
  CATEGORIES.JOBS,
  CATEGORIES.EDUCATIONAL_EXCHANGE,
  CATEGORIES.PEOPLE,
];

export const ITEMS_BY_CATEGORIES = {
  [CATEGORIES.INVESTMENT]: [ITEMS.GOOD_EXPORTS, ITEMS.SERVICE_EXPORTS, ITEMS.TOTAL_EXPORTS, ITEMS.GREENFIELD],
  [CATEGORIES.JOBS]: [ITEMS.JOBS_DIRECTLY, ITEMS.JOBS_INIDRECTLY, ITEMS.JOBS_CREATED],
  [CATEGORIES.EDUCATIONAL_EXCHANGE]: [ITEMS.NUMBER_OF_STUDENTS, ITEMS.ECONOMIC_IMPACT],
  [CATEGORIES.PEOPLE]: [ITEMS.VISITOR_SPENDING, ITEMS.POPULATION, ITEMS.NUMBER_OF_SISTER_CITIES],
};
